// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "." + {"772":"65f0819a13966d73","4705":"e40ce280ed3fe810","8952":"8b1243d98cd4edfc"}[chunkId] + ".js";
};